import classNames from 'classnames/bind'
import PropTypes from 'prop-types'

import React from 'react'
import {DataTable} from '../base/DataTable.jsx'

import {
    Box, Toolbar, Button, LinkButton,
    ToolButton, LinkToolButton,
    Upload, Search, TagList,
    FormattedDate, IconFold, Row
} from '../base/Elements.jsx'

import {Http, i18n, exportToFile} from 'common'


export class AdminPage extends React.Component {
    static contextTypes = {
        config: PropTypes.object.isRequired,
        notificator: PropTypes.object.isRequired
    }

    state = {
        items: [],
        filteredItems: null
    }

    componentDidMount() {
        this.onReload(this.props)
    }

    // componentWillReceiveProps(props) {
    //   this.onReload(props);
    // }

    onReload = () => {
        const {sortBy} = this.config

        Http.GET(this.config.url, (data) => {
            const items =
                (data && sortBy) ? data.sort(sortBy) : data

            this.setState({items: data}, () => (
                this.onCompleteLoad &&
                    this.onCompleteLoad(data)
            ))
        })
    }

    onDelete = (ev) => {
        ev.preventDefault()

        const result = confirm('Are you sure you want to remove the record?');
        if (!result) { return }

        const target = ev.currentTarget;
        const id = target.getAttribute('data-id')
        const url = target.getAttribute('data-url')


        Http.DELETE(url + id, null, () => {
            this.context.notificator.message('Succesfully deleted')
            this.context.config.forceUpdate()
            this.onReload()
        })
    }


    onRenderHeader = () => (
        <tr>
            {this.config.columns.map((i, index) => {
                switch (i.type) {
                    case 'fold':
                    return (
                        <th key={index} className="table-30p"></th>
                    )

                    case 'date':
                    return (
                        <th key={index} className="table-200p txtcenter">{i.title}</th>
                    )

                    case 'actions':
                    return (
                        <th key={index} className={`${i.className} txtcenter`}></th>
                    )

                    default:
                    return (
                        <th key={index} className={i.className}>{i.title}</th>
                    )
                }
            })}
        </tr>
    )

    onRenderRow = (item, index) => (
        <Row key={index}>
            {this.config.columns.map((col, colIndex) => {
                const {config} = this.context

                switch (col.type) {
                    case 'render':
                        return col.getter(item, colIndex)

                    case 'fold':
                        return (
                            <td key={colIndex}><IconFold /></td>
                        )

                    case 'date':
                        return (
                            <td key={colIndex} className="txtcenter">
                                <FormattedDate>{item[col.getter]}</FormattedDate>
                            </td>
                        )

                    case 'list':
                        const list = item[col.getter]
                        const isEmpty = (list.length === 0)

                        return (
                            <td key={colIndex}>
                                {isEmpty ?
                                    <span className="tag tag--red"><i className="fa fa-ban mr05" />No items</span>
                                    : list.join(', ')
                                }
                            </td>
                        )

                    case 'tag-list':
                        return (
                            <td key={colIndex}>
                                <TagList items={item[col.getter]} store={config} />
                            </td>
                        )

                    case 'actions':
                        const getButtonParams = (url) => {
                            if (url == null)
                                return null

                            if (typeof url === 'string')
                                return {url: `${url}${item.id}`}
                            else
                                return url(config, item)
                        }

                        const whiltelistParams =
                            getButtonParams(col.allows['Whitelist'])

                        return (
                            <td key={colIndex} className="table-actions">
                                <div>
                                    {col.allows['Edit'] != null &&
                                        <LinkToolButton title={i18n('input.edit')} url={`${getButtonParams(col.allows['Edit']).url}`} icon="pencil" className="mr1" />}

                                    {col.allows['Whitelist'] != null &&
                                        <LinkToolButton title={i18n('input.whitelist')} url={whiltelistParams.url} icon="shield" type="secondary" className={classNames("mr1", whiltelistParams.class)} />}

                                    {col.allows['Delete'] != null &&
                                        <ToolButton title={i18n('input.delete')} icon="trash" type="danger" data-url={col.allows['Delete']} data-id={item.id} onClick={this.onDelete} />}

                                    {col.allows['Revoke'] != null &&
                                        <ToolButton title={i18n('input.revoke')} icon="trash" type="danger" data-url={col.allows['Revoke']} data-id={item.id} onClick={this.onDelete} />}
                                </div>
                            </td>
                        )

                    case 'label':
                        return (
                            <td key={colIndex}><span className="tag tag--blue">
                                <i className={`icon fa fa-${item[col.getter[1]]} mr05`} />{item[col.getter[0]]}</span>
                            </td>
                        )

                    case 'string':
                        return (
                            <td key={colIndex}>{item[col.getter]}</td>
                        )
                }
            })}
        </Row>
    )

    onImport = (e) => {
        const reader = new FileReader()
        reader.onload = () => {
            const text = reader.result
            const data = JSON.parse(text)
            console.log(data)
        }

        reader.readAsText(e.target.files[0]);
    }

    onExport = () => {
        exportToFile(this.state.items)
    }

    onSearch = (ev) => {
        const {target: {value}} = ev

        const filteredItems = (value && value !== '') ?
            this.config.filter(value, this.state.items) : null

        this.setState({filteredItems})
    }


    render() {
        const {items: allItems, filteredItems} = this.state
        const {layout} = this.config

        const items = filteredItems || allItems

        return (
            <div className={classNames({box: layout !== 'none'})}>
                {this.onRenderToolbar && this.onRenderToolbar()}

                <Toolbar>
                    <div>
                        {this.config.addButton &&
                            <LinkButton
                                title={this.config.addButton.title}
                                url={this.config.addButton.url}
                                icon="plus"
                            />
                        }

                        {this.config.filter &&
                            <Search
                                placeholder='Search...'
                                style={{marginLeft: '10px'}}
                                onChange={this.onSearch}
                            />
                        }

                        <Button
                            title='Export'
                            icon='arrow-down'
                            onClick={this.onExport}
                            style={{marginLeft: '25px'}}
                        />

                        <Upload
                            title='Import'
                            icon='arrow-up'
                            onChange={this.onImport}
                        />
                    </div>
                </Toolbar>

                <DataTable
                    items={items}
                    onRenderHeader={this.onRenderHeader}
                    onRenderRow={this.onRenderRow}
                />
            </div>
        );
    }
}
